import { buildProps } from '@lit-element/utils'
import type { ExtractPropTypes, PropType } from 'vue'
import type highlight from './highlight.vue'

export const highlightProps = buildProps({
  /**
   * @description 要高亮的文本
   */
  text: {
    type: String,
    default: '',
  },
  /**
   * @description 关键词
   */
  keyword: {
    type: Array as PropType<string[]>, // 明确指定数组元素类型
    default: () => [],
  },
  /**
   * @description 区分字母大小写
   */
  caseSensitive: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 高亮内容的类名
   */
  highlightStyle: {
    type: Object as PropType<{ [key: string]: string }>,
    default: () => ({ backgroundColor: 'yellow' }),
  },
} as const)

export type HighLightProps = ExtractPropTypes<typeof highlightProps>
export type HighLightInstance = InstanceType<typeof highlight>
